import React from "react";
import { useStyles } from "../../../styles/styles";
import type { ContentItem } from "@/pages/ClientProfile/types";
import { defaultIsSensitiveField } from "@/pages/ClientProfile/utils";
import TaxInfoField from "@pages/ClientProfile/components/TaxInfo/items/TaxInfoField.tsx";

interface FieldItemProps {
  item: ContentItem & { type: "field" };
}

const defaultShouldIncludeField = (): boolean => true;

const defaultFormatKey = (keyName: string): string => keyName;

const FieldItem: React.FC<FieldItemProps> = ({ item }) => {
  const { classes } = useStyles();

  // Convert null values to empty strings while preserving other values
  const fieldValue =
    item.value === null || item.value === undefined || item.value === ""
      ? "-"
      : item.value;

  return (
    <div className={classes.field}>
      <TaxInfoField
        keyName={item.label}
        value={fieldValue}
        uniqueKey={item.key}
        shouldIncludeField={defaultShouldIncludeField}
        isSensitiveField={defaultIsSensitiveField}
        formatKey={defaultFormatKey}
      />
    </div>
  );
};

export default FieldItem;
